import React from 'react';

interface ExternalLinkProps {
  href: string;
  children: React.ReactNode;
  className?: string;
}

/**
 * ExternalLink component creates a properly formatted anchor tag for external links
 * with security best practices (rel attributes) and accessibility support.
 */
function ExternalLink({ href, children, className = '' }: ExternalLinkProps) {
  return (
    <a 
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
    >
      {children}
    </a>
  );
}

export default ExternalLink; 